import useSWR from 'swr';
import axios from 'axios';
import useDebounce from '../../../../hooks/useDebounce';
import LogisticServiceListingCard from '../LogisticServiceListingCard/LogisticServiceListingCard';
import { getLogisticServicesListingData } from '../../../../services/services';
import useFiltersState from '../../../../state/useFiltersState';
import LogisticsServiceListingCardSkeletonLoader from '../LogisticsServiceListingCardSkeletonLoader/LogisticsServiceListingCardSkeletonLoader';
import { useEffect, useState } from 'react';
import errorMessage from '../../../../utils/errorMessage';
import './LogisticServiceListing.scss';

const LogisticServiceListing = ({
  searchText,
  changeStateFirsLoadSecondList
}: {
  searchText: string;
  changeStateFirsLoadSecondList: (state: boolean) => void;
}) => {
  const [makeFirstChargeSecondList, setMakeFirstChargeSecondList] = useState<boolean>(false);
  const { logisticsServicesListingFilters } = useFiltersState();
  const debouncedSearchText = useDebounce(searchText, 1500);
  const searchTextQueryParam = `${debouncedSearchText ? `search=${debouncedSearchText.trim()}` : ''}`;
  const filtersQueryParam =
    logisticsServicesListingFilters && logisticsServicesListingFilters.length
      ? `filters=${JSON.stringify(logisticsServicesListingFilters)}`
      : '';
  const debouncedFiltersQueryParams = useDebounce(filtersQueryParam, 800);
  const queryParams =
    searchTextQueryParam || debouncedFiltersQueryParams
      ? `?${debouncedFiltersQueryParams}${
          debouncedFiltersQueryParams ? `&${searchTextQueryParam}` : searchTextQueryParam
        }`
      : '';
  const swrKey = `/logistic-service/backoffice/listing${queryParams}`;

  const {
    data: logisticServicesGeneral,
    isLoading,
    error
  } = useSWR(swrKey, getLogisticServicesListingData, {
    suspense: false
  });

  const initalLoader = () => {
    if (!isLoading || logisticServicesGeneral || error) {
      if (!makeFirstChargeSecondList) {
        setMakeFirstChargeSecondList(true);
        changeStateFirsLoadSecondList(false);
      }
      if (error) {
        if (axios.isCancel(error)) {
          console.error('estado:request:', error?.message);
        } else {
          errorMessage();
        }
      }
    }
  };

  useEffect(() => {
    initalLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, logisticServicesGeneral, error]);

  return (
    <div className="LogisticServiceListing">
      <div className="LogisticServiceContainer">
        <div className="LogisticServiceColumn country">País</div>
        <div className="LogisticServiceColumn business">Empresa</div>
        <div className="LogisticServiceColumn id">ID</div>
        <div className="LogisticServiceColumn origin">Origen</div>
        <div className="LogisticServiceColumn destination">Destino</div>
        <div className="LogisticServiceColumn state">Estado</div>
        <div className="LogisticServiceColumn services">Servicios</div>
        <div className="LogisticServiceColumn comments">Comentarios</div>
        <div className="LogisticServiceColumn notes">Notas internas</div>
        <div className="LogisticServiceColumn provider">Proveedor</div>
        <div className="LogisticServiceColumn price">Precio del SL</div>
      </div>
      <div className="containerLSList">
        {isLoading && [...Array(30)].map(index => <LogisticsServiceListingCardSkeletonLoader key={index} />)}
        {!isLoading &&
          !!logisticServicesGeneral?.length &&
          logisticServicesGeneral?.map(logisticServiceData => (
            <LogisticServiceListingCard logisticServiceData={logisticServiceData} />
          ))}
        {!isLoading && !logisticServicesGeneral?.length && (
          <div className="noLogisticServiceResults">No hay resultados</div>
        )}
      </div>
    </div>
  );
};

export default LogisticServiceListing;
